<template>
  <div id="about">
    <div class="content_box">

      <div class="img_container about_img"></div>

      <div class="contents_title fade_in"> 
        <p class="contents_font"> About KS LAB </p>
      </div>

      <div class="content_info">
        <div class="quote_container margin_item">
          <div class="quote_item">
            <div class="start_quote"></div>
          </div>
          <div class="quote_info_item">
            <p class="main_font pline"> 주식회사 케이에스랩은 </p>
            <p class="info_font pline"> 전기차 데이터 수집 단말기 개발 및 데이터 분석을 기반으로 </p>
            <p class="info_font"> 전기차 차량관리 솔루션을 제공하는 업체입니다.</p>
          </div>
          <div class="quote_item">
            <div class="end_quote"></div>
          </div>

        </div>
        <History />
        <Certificate />
      </div>
    </div>
  </div>
</template>

<script>
import History from "@/components/History";
import Certificate from "@/components/Certificate";

export default {
  components: {
    History,
    Certificate,
  },
};
</script>

<style>
#about {
  text-align: center;
}

.about_img {
  background-image: url(../../public/img/about.jpg);
  filter: brightness(50%); 
}  

@media screen and (max-width: 479px) {
  .main_font {
    font-size: 20px;
  }
  .sub_font {
    font-size: 17px;
  }
  .info_font {
    font-size: 15px;
  }
  .subinfo_font {
    font-size: 12px;
  }
  .businass_item {
    width: 350px;
    height: 470px;
  }
}
</style>
